import * as yup from 'yup'
export const NO_SPECIAL_CHAR = /^[^!@#$%^&*()+=\\[\]{};:'",.<>?/`~]*$/

export const areaSchema = yup.object({
  _id: yup.string().required(), // assuming _id is required

  shortCode: yup
    .string()
    .required('Short code is required')
    .matches(NO_SPECIAL_CHAR, 'Short code must not contain special characters'),

  fullName: yup
    .string()
    .required('Full name is required')
    .min(2, 'Full name must be at least 2 characters')
    .max(50, 'Full name must be at most 50 characters'),
})

export const areasFormSchema = yup.object({
  areas: yup.array().of(areaSchema).required('Areas are required'),
})

export const newAreaSchema = yup.object({
  shortCode: yup
    .string()
    .required('Short code is required')
    .matches(NO_SPECIAL_CHAR, 'Short code must not contain special characters'),

  fullName: yup
    .string()
    .required('Full name is required')
    .min(2, 'Full name must be at least 2 characters')
    .max(50, 'Full name must be at most 50 characters'),
})
